import axios from 'axios';
import { getCookie } from '../utils/cookies';
import { clearSelectedCompanyContext } from '../utils/selectedCompany';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';

export const signup = async (username, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/signup`, { username, password });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Registro falló. Intente nuevamente.');
  }
};

export const login = async (username, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, { username, password }, {
      withCredentials: true, // ✅ Needed for cookies/auth
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Inicio de sesión falló. Intente nuevamente.');
  }
};

export const getToken = () => {
  return getCookie('token') || '';
};

export const isTokenExpired = (token, now = Date.now()) => {
  if (!token) return true;
  try {
    const payloadPart = String(token).split('.')[1];
    if (!payloadPart) return true;
    const normalized = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    const payload = JSON.parse(window.atob(padded));
    const expiresAt = Number(payload?.exp) * 1000;
    return !Number.isFinite(expiresAt) || expiresAt <= now;
  } catch {
    return true;
  }
};

export const tokenExists = () => {
  const token = getToken();
  return Boolean(token) && !isTokenExpired(token);
};

export const clearAuthToken = () => {
  document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax';
};

export const handleLogout = () => {
  clearAuthToken();
  clearSelectedCompanyContext();
  window.location.reload();
};

export const getSession = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${API_URL}/auth/session`, {
      withCredentials: true,
      skipCompanyContext: true,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    error.message = error.response?.data?.message || 'Error al obtener la sesión';
    throw error;
  }
};

export const getMe = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${API_URL}/auth/me`, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    error.message = error.response?.data?.message || 'Error al obtener usuario';
    throw error;
  }
};

export const updateMyName = async (data) => {
  const token = getToken();
  try {
    const response = await axios.patch(`${API_URL}/auth/me`, data, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error al actualizar nombre');
  }
}
